import React, { useCallback, useMemo } from 'react';
import { useFetch } from '../utils/hooks';
import { getUser } from '../services/user';

const UserContext = React.createContext();

const UserProvider = ({ children }) => {
  const getUserCallback = useCallback(getUser, []);
  const { data, loading } = useFetch(getUserCallback);
  const user = data?.user;

  return (
    <UserContext.Provider value={{ user, loading }}>
      {children}
    </UserContext.Provider>
  );
};

export { UserProvider };
export default UserContext;
